import React, { useEffect, useState } from "react";
import { Row, Col, Layout, Menu, Drawer, Badge, Divider, Dropdown } from "antd";
import "./sideMenu.css";
import Logo from "../../assets/images/logo-sec.png";
import LogoSideMenu from "../../assets/images/logo-sidemenu.png";
import { BsSoundwave, BsArrowLeftShort } from "react-icons/bs";
import { HiUserCircle } from "react-icons/hi";
import { AiFillTool, AiOutlineMenu, AiFillBell } from "react-icons/ai";
import { MdOutlineCreditCard } from "react-icons/md";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { GiMineTruck } from "react-icons/gi";
import { MdOutlinePhoneAndroid } from "react-icons/md";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import styled from "styled-components";
import HeaderImage from "../../assets/images/header.jpg";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { DashboardAction, UserAction } from "../../store/actions";
import HeaderComponent from "../header";
import DriverContainer from "../../containers/Drivers";
const { Header, Sider, Content } = Layout;

const SideMenuWrapper = styled(Sider)`
  flex: ${(props) =>
    props.collapsed ? "0 0 50px !important" : "0 0 200px !important"};
  min-width: ${(props) =>
    props.collapsed ? "60px !important" : "200px !important"};
  width: ${(props) =>
    props.collapsed ? "60px !important" : "200px !important"};
`;

function SideMenu(props) {
  const [collapsed, setCollapsed] = useState(true);
  const toggle = () => {
    setCollapsed(!collapsed);
  };
  const dispatch = useDispatch();
  const isWide = useMedia({ minWidth: 600 });
  const history = useHistory();
  const [isVisible, setIsVisible] = useState(false);

  const componentName = props.location.pathname;
  const userName = useSelector((store) => store.AuthReducer.user);
  console.log("userName===>", userName);
  const userDetail = useSelector((store) => store.UserReducer?.userDetails);
  console.log("details==>", userDetail);
  const notification = useSelector(
    (store) => store.DashboardReducer.notification
  );

  const companyDetails = useSelector(
    (store) => store.UserReducer.companyDetails
  );

  // const companyDetails = useSelector(
  //   (store) => store.UserReducer.companyDetails
  // );
  useEffect(() => {
    dispatch(UserAction.getCompantDetailReq());
  }, []);

  let addressName = "";
  switch (componentName) {
    case "/dashboard":
      addressName = "Logistics Partner";
      break;
    case "/employees":
      addressName = "Employees";
      break;
    case "/accounts":
      addressName = "Account Settings";
      break;
    case "/drivers":
      addressName = "Drivers";
      break;
    case "/accounts":
      addressName = "Account Settings";
      break;
    case "/welcome":
      addressName = "Welcome";
      break;
    case "/catalog/new":
      addressName = "New Product";
      break;
    default:
      addressName = addressName;
  }
  let key = "";

  switch (componentName) {
    case "/dashboard":
      key = "1";
      break;
    case "/employees":
      key = "2";
      break;
    case "/drivers":
      key = "3";
      break;
    case "/accounts":
      key = "4";
      break;
    case "/creditors":
      key = "5";
      break;
    case "/welcome":
      key = "6";
      break;
    case "/pavers":
      key = "7";
      break;
    default:
      key = key;
  }

  const menu = (
    <Menu>
      {!!notification.length ? (
        notification.map((item) => {
          return (
            <Row
              onClick={() => {
                !componentName.includes("order")
                  ? history.push(`order/${item?.data?.order?.id}`)
                  : history.push(`${item?.data?.order?.id}`);
                !item.is_read &&
                  dispatch(DashboardAction.isMarkReadReq(item.id));
              }}
              className="pointer-cursor"
              style={{
                backgroundColor: item.is_read ? "white" : "#F5F5F5",
                padding: "10px",
              }}
            >
              <Col xl={24} xs={24} className="d-flex align-item-middle">
                <Badge status="warning" />
                <span
                  className="d-flex align-item-middle"
                  style={{ fontSize: "11.5px" }}
                >
                  You have a new order{" "}
                  <strong style={{ marginLeft: "6px", fontSize: "14px" }}>
                    #{item?.data?.order?.order_number}
                  </strong>
                </span>
              </Col>
              <Col span={2}></Col>
              <Col span={22}>
                <span style={{ fontSize: "12px" }}>
                  {moment(item?.created_at).utc().fromNow()}
                </span>
              </Col>
              <Col span={24}>
                <Divider />{" "}
              </Col>
            </Row>
          );
        })
      ) : (
        <Row
          className="pointer-cursor"
          style={{
            backgroundColor: "#F5F5F5",
            padding: "10px",
          }}
        >
          <Col xl={24} xs={24} className="d-flex align-item-middle">
            <Badge status="warning" />
            <span
              className="d-flex align-item-middle"
              style={{ fontSize: "11.5px" }}
            >
              No New Notification
            </span>
          </Col>
        </Row>
      )}
    </Menu>
  );
  const markAsRead = notification.filter((item) => !item.is_read);
  return (
    <Layout>
      {!isWide ? (
        <Drawer
          placement="left"
          width="70%"
          onClose={toggle}
          visible={!collapsed}
          closeIcon={false}
          extra={
            <div>
              <img
                src={
                  collapsed
                    ? companyDetails?.logistics_partner_asset?.logo?.original
                    : Logo
                }
                width={"100%"}
              />
            </div>
          }
        >
          <Menu theme="dark" mode="inline">
            <Menu.Item key="1" icon={<BsSoundwave size="25" />}>
              <Link to="/dashboard">Dashboard</Link>
            </Menu.Item>
            <Menu.Item key="2" icon={<HiUserCircle size="25" />}>
              <Link to="/employees"> Employees</Link>
            </Menu.Item>
            <Menu.Item key="3" icon={<GiMineTruck size="25" />}>
              <Link to="/drivers">Drivers</Link>
            </Menu.Item>
            <Menu.Item key="7" icon={<MdOutlinePhoneAndroid size="25" />}>

              <Link to="/pavers">Pavers</Link>
            </Menu.Item>
            <Menu.Item key="4" icon={<AiFillTool size="25" />}>
              <Link to="/accounts">Accounts</Link>
            </Menu.Item>

            <Menu.Item
              key="5"
              onClick={() => {
                localStorage.clear();
                // history.push("/signin");
                window.location.reload();
              }}
              icon={<RiLogoutBoxRLine size="25" />}
            >
              logout
            </Menu.Item>
            <Menu.Item key="6" icon={<BsSoundwave size="25" />}>
              <Link to="welcome">Welcome</Link>
            </Menu.Item>
          </Menu>
        </Drawer>
      ) : (
        <SideMenuWrapper
          trigger={null}
          collapsible
          collapsed={collapsed}
          style={{
            overflow: "auto",
            height: "100vh",
            position: "sticky",
            top: 0,
            left: 0,
            zIndex: "10000000",
          }}
        >
          <div style={{ backgroundColor: "black", height: '3em' }}>
            {console.log("heeello==>", companyDetails)}
            <span>
              <img
                src={
                  collapsed
                    ? companyDetails?.logistics_partner_asset?.logo?.original
                    : Logo
                }
                width={collapsed ? "40px" : "170px"}
                height={collapsed ? "40px" : "40px"}
                className={collapsed && "border-rounded"}
                style={{ backgroundPosition: 'center center', objectFit: !collapsed && 'contain' }}
              />
            </span>
          </div>{" "}
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={key}
            className={!collapsed ? "custom" : "collapsed-custom"}
          >
            <Menu.Item key="1" icon={<BsSoundwave size="25" />}>
              <Link to="/dashboard">Dashboard</Link>
            </Menu.Item>
            <Menu.Item key="2" icon={<HiUserCircle size="25" />}>
              <Link to="/employees"> Employees</Link>
            </Menu.Item>
            <Menu.Item key="3" icon={<GiMineTruck size="25" />}>
              <Link to="/drivers">Drivers</Link>
            </Menu.Item>
            <Menu.Item key="7" icon={<MdOutlinePhoneAndroid size="25" />}>
              <Link to="/pavers">Pavers</Link>
            </Menu.Item>
            <Menu.Item key="4" icon={<AiFillTool size="25" />}>
              <Link to="/accounts">Accounts</Link>
            </Menu.Item>

            <Menu.Item
              key="5"
              onClick={() => {
                localStorage.clear();
                // history.push("/signin");
                window.location.reload();
              }}
              icon={<RiLogoutBoxRLine size="25" />}
            >
              logout
            </Menu.Item>
            <Menu.Item key="6" icon={<BsSoundwave size="25" />}>
              <Link to="welcome">Welcome</Link>
            </Menu.Item>
          </Menu>
        </SideMenuWrapper>
      )}

      <Layout className="site-layout">
        {isWide ? (
          <header class="st-bg-header">
            <h2
              class={
                collapsed
                  ? "page-heading left  "
                  : "page-heading left active-sidenav "
              }
              style={{ display: "inline-block" }}
            >
              <span>
                <i class="left material-icons">
                  {" "}
                  <AiOutlineMenu
                    style={{
                      padding: "3px",
                      float: "left",
                      marginLeft: "-0.4rem",
                    }}
                    className="pointer-cursor"
                    color="white"
                    size="25"
                    onClick={toggle}
                  />
                </i>
              </span>
              <span class="icon-btn"></span>
              {/* {{activeRoute}} */}
              {/* {addressName} */}
              {!componentName.includes("order") && addressName}
            </h2>
            {isWide && (
              <div
                class=" right"
                style={{
                  display: "flex",
                  marginRight: "6px",
                }}
              >
                <Dropdown
                  overlay={menu}
                  trigger={["click"]}
                  overlayClassName={
                    !!notification.length
                      ? "notification-dropdown-class"
                      : "no-dropdown-class"
                  }
                >
                  <Badge
                    count={markAsRead.length}
                    style={{
                      backgroundColor: "#f9a01b",
                      width: "15px",
                    }}
                    size="small"
                    offset={[-20, 5]}
                    className="logistics-ant-scroll-number"
                  >
                    <AiFillBell
                      color="white"
                      size={"22"}
                      onClick={() => setIsVisible(!isVisible)}
                      className="pointer-cursor "
                      style={{
                        borderRadius: "50%",
                      }}
                    />
                  </Badge>
                </Dropdown>
                <span style={{ color: "white" }}>
                  Welcome{" "}
                  <a class="orange-text">
                    {`${userDetail?.first_name || "-"} ${userDetail?.last_name || "-"}`}
                  </a>
                </span>
              </div>
            )}
          </header>
        ) : (
          <Row
            style={{
              width: "100%",
              height: "3rem",
              position: "fixed",
              zIndex: "1",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundImage: `url(${HeaderImage})`,
            }}
            align="middle"
            justify="space-between"
          >
            <Col span={24}>
              <Row align="middle" justify="start">
                <Col xs={3} sm={2}>
                  {addressName === "New Product" ? (
                    <BsArrowLeftShort
                      style={{
                        float: "left",
                        marginLeft: "0.5rem",
                      }}
                      color="white"
                      size={"30"}
                      onClick={() => history.push("/catalog")}
                      className="pointer-cursor"
                    />
                  ) : (
                    <AiOutlineMenu
                      style={{
                        float: "left",
                        marginLeft: "0.5rem",
                      }}
                      className="pointer-cursor"
                      color="white"
                      size="25"
                      onClick={toggle}
                    />
                  )}
                </Col>
                <Col xs={18} sm={18}>
                  <h2 className="text-white text-capitilize text-left">
                    {!componentName.includes("order") ? addressName : null}
                  </h2>
                </Col>
              </Row>
            </Col>
            {isWide && (
              <Col xl={11} xs={18} sm={11} md={12} lg={12}>
                <Row
                  id="toggle-id"
                  justify={!collapsed ? "center" : "end"}
                  align="middle"
                  style={{ marginRight: "65px" }}
                >
                  <Col xl={1} xs={1} sm={2} lg={2} md={1}>
                    <Dropdown
                      overlay={menu}
                      trigger={["click"]}
                      overlayClassName="notification-dropdown-class"
                    >
                      <Badge
                        count={markAsRead.length}
                        style={{ backgroundColor: "#f9a01b" }}
                        size="small"
                        offset={[-20, 5]}
                      >
                        <AiFillBell
                          color="white"
                          size={"25"}
                          onClick={() => setIsVisible(!isVisible)}
                          className="pointer-cursor"
                        />
                      </Badge>
                    </Dropdown>
                  </Col>
                  <Col
                    xl={2}
                    xs={1}
                    sm={5}
                    md={5}
                    lg={2}
                    style={{ marginRight: "5px" }}
                  >
                    <span className="color-white">Welcome</span>
                  </Col>
                  <Col xl={4} xs={18} sm={7} md={5} lg={4}>
                    <span
                      className="text-right three-dot"
                      style={{ color: "orange" }}
                    >
                      {`${userDetail?.first_name || "-"} ${userDetail?.last_name || "-"
                        }`}
                    </span>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
        )}

        <Content
          className="site-layout-background"
          style={{
            // margin: "24px 16px",
            // padding: 24,
            margin: "24px 8px",
            padding: "12px",
            minHeight: 280,
          }}
        >
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
}
export default SideMenu;
